import { h, render } from 'preact';

import './kickstart';

import RelatedContent from './components/RelatedContent';

import drawContribs from './contribs-by-day';
// import drawMaps from './zip-maps';

import debounce from './utils/debounce';
// import draw from './zip-maps';

drawContribs();
// drawMaps();

const debouncedDraw = debounce(() => {
  drawContribs();
  // drawMaps();
}, 300);

window.addEventListener('resize', debouncedDraw);

render(
  <RelatedContent title="More Texas U.S. Senate stories" />,
  document.getElementById('related-content-container')
);



// WEBPACK FOOTER //
// ./main.js